__turbopack_context__.v({
  "badge-container": "TJxXTq_badge-container",
  "button-container": "TJxXTq_button-container",
  "clickable-container": "TJxXTq_clickable-container",
  "content-container": "TJxXTq_content-container",
  "disclaimer-container": "TJxXTq_disclaimer-container",
  "footer-container": "TJxXTq_footer-container",
  "result-card": "TJxXTq_result-card",
  "result-container": "TJxXTq_result-container",
  "spot-icon-container": "TJxXTq_spot-icon-container",
});
